import auth from 'src/router/auth'
import Service from '../Service'
import NewService from '../NewService'
import EditService from '../EditService'
export default [
  {
    path: '/services',
    name: 'services',
    component: Service,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/services/new',
    name: 'create-service',
    component: NewService,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/services/:id/edit',
    name: 'edit-service',
    component: EditService,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/service/routes/index.js